import {
  BaseProcManagementPlacesListService,
  ContextProps as BaseProps,
} from "./place-list-base";

export type AdditionalProps = object;

export type ContextProps = BaseProps & AdditionalProps;

export class ProcManagementPlacesListService extends BaseProcManagementPlacesListService<AdditionalProps> {
  constructor() {
    super({});
  }
}
